export default "__VITE_ASSET__D4eFdep5__"